"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCampaignServiceAssetRequestToJSON = exports.CreateCampaignServiceAssetRequestFromJSONTyped = exports.CreateCampaignServiceAssetRequestFromJSON = exports.instanceOfCreateCampaignServiceAssetRequest = exports.CreateCampaignServiceAssetRequestTypeEnum = void 0;
/**
 * @export
 */
exports.CreateCampaignServiceAssetRequestTypeEnum = {
    SurveyAsset: 'SURVEY_ASSET',
    LinkedAsset: 'LINKED_ASSET'
};
/**
 * Check if a given object implements the CreateCampaignServiceAssetRequest interface.
 */
function instanceOfCreateCampaignServiceAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
exports.instanceOfCreateCampaignServiceAssetRequest = instanceOfCreateCampaignServiceAssetRequest;
function CreateCampaignServiceAssetRequestFromJSON(json) {
    return CreateCampaignServiceAssetRequestFromJSONTyped(json, false);
}
exports.CreateCampaignServiceAssetRequestFromJSON = CreateCampaignServiceAssetRequestFromJSON;
function CreateCampaignServiceAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
exports.CreateCampaignServiceAssetRequestFromJSONTyped = CreateCampaignServiceAssetRequestFromJSONTyped;
function CreateCampaignServiceAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}
exports.CreateCampaignServiceAssetRequestToJSON = CreateCampaignServiceAssetRequestToJSON;
